<template lang="pug">
    .columns.is-vcentered.is-mobile
      .container.column.p0
        .columns.is-centered
          .column.is-three-fifths.has-text-centered
            h1 {{$t('componentes.coletor.views.triagemColetor.titulo')}}
            img(:src="require('../../../../static/images/coletor.svg')")
        .columns.is-centered
          .column.is-three-fifths.has-text-centered
            p {{$t('componentes.coletor.views.triagemColetor.textoColetorExistente')}}
        br
        .columns.is-centered
          .column.is-one-quarter
            Button3d(@click="acessarRotaCadastroDeColetor" color="success" size="medium" :block="true") {{$t('componentes.coletor.views.triagemColetor.textoNovoColetor')}}
          .column.is-one-quarter
            Button3d(@click="acessarRotaListaDeColetores" color="info" size="medium" :block="true") {{$t('componentes.coletor.views.triagemColetor.textoConfiguracoesExistentes')}}
        br
        .columns.is-centered.has-text-centered
            router-link(:to="{ name: 'clear'}") {{$t('componentes.coletor.views.triagemColetor.textoFazerLoginNovamente')}}
</template>

<script>
export default {
  name: 'TriagemColetor',
  methods: {
    acessarRotaListaDeColetores () {
      this.$router.push({ name: 'listaColetores' })
    },
    acessarRotaCadastroDeColetor () {
      this.$router.push({ name: 'criarColetor' })
    }
  }
}
</script>
